import { useState } from "react";
import { InView } from "react-intersection-observer";
import posthog from "posthog-js";

import useAppSelector from "@/hooks/useAppSelector";
import { recombeeToCart } from "@/utils/product";

import type { RecombeeValuesItemUser } from "@/types/recombee";
import { useQuery } from "@tanstack/react-query";

import { getRelatedWhatYouSawRecommendations } from "@/services/recombee";
import SwiperSectionProductGallery from "@/components/Organisms/SwiperSectionProductGallery";
import useSessionContext from "@/hooks/useSesionContext";

const RelatedLastThingYouSaw = () => {
  const { isAthenticated } = useSessionContext();
  const storeId = useAppSelector((state) => state.cart.storeId);
  const userID = posthog.get_distinct_id();
  const [inView, setInView] = useState(false);

  const { data, isSuccess, isFetching } = useQuery({
    queryKey: ["relatedLastThingYouSaw", userID, storeId, isAthenticated()],
    queryFn: async () => {
      const result = await getRelatedWhatYouSawRecommendations(userID, String(storeId));

      if (!result.data?.success) {
        throw new Error("No data");
      }

      const { payload } = result.data;

      const items: Cart[] = payload.recomms.map((recom) =>
        recombeeToCart(Number(recom.id), storeId!, recom.values as unknown as RecombeeValuesItemUser)
      );

      return {
        items,
        id: result.data.recommId,
      };
    },
    enabled: !!userID && !!storeId && inView,
  });

  if (isFetching || !isSuccess || !userID || !storeId || (data?.items && data.items.length <= 0)) {
    return null;
  }

  return (
    <InView
      onChange={(isView) => {
        if (!inView) setInView(isView);
      }}
      rootMargin="1500px 0px"
      triggerOnce
    >
      <SwiperSectionProductGallery
        items={data?.items ?? []}
        title={"Relacionado con lo último que viste"}
        recommId={data?.id}
        addPadding
      />
    </InView>
  );
};

export default RelatedLastThingYouSaw;
